var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAnnouncementFocus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 30,
    viewBox: "0 0 27 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.65 21.15C25.65 21.15 25.5 21 25.5 20.85C24.6 19.95 24 19.05 23.55 18.15C22.8 16.65 22.5 14.55 22.5 12.15C22.5 9.9 21.75 7.95 20.4 6.3C19.05 4.65 17.25 3.6 15 3.15V1.8C15 1.35 14.85 0.9 14.4 0.45C13.95 0.15 13.5 0 13.05 0C12.6 0 12.15 0.15 11.7 0.6C11.4 0.9 11.25 1.35 11.25 1.8V3C9 3.45 7.2 4.5 5.85 6.15C4.35 7.95 3.75 9.9 3.75 12.15C3.75 14.55 3.45 16.65 2.7 18.15C2.25 19.05 1.65 19.95 0.75 20.85L0.6 21.15C0.3 21.6 0 22.05 0 22.5C0 22.95 0.15 23.4 0.6 23.85C0.9 24.15 1.35 24.45 1.95 24.45H24.45C25.05 24.45 25.5 24.3 25.8 23.85C26.1 23.55 26.4 23.1 26.4 22.5C26.25 22.05 25.95 21.6 25.65 21.15ZM3.9 21.6C5.55 19.35 6.45 16.2 6.45 12.3C6.45 11.1 6.75 10.05 7.35 9C7.95 7.95 8.7 7.2 9.75 6.6C10.8 6 11.85 5.7 13.05 5.7C14.25 5.7 15.3 6 16.35 6.6C17.4 7.2 18.15 7.95 18.75 9C19.35 10.05 19.65 11.1 19.65 12.3C19.65 16.2 20.55 19.35 22.2 21.6H3.9Z",
    fill: "#A1A1A1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.35 28.95C11.1 29.7 12 30 13.05 30C14.1 30 15 29.7 15.75 28.95C16.5 28.2 16.8 27.3 16.8 26.25H9.30005C9.30005 27.3 9.60005 28.2 10.35 28.95Z",
    fill: "#F68121"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnnouncementFocus);
export default __webpack_public_path__ + "static/media/announcement-focus.f3ff399377174a479462e12937fefb68.svg";
export { ForwardRef as ReactComponent };